import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M847.058824,113 C1103.20941,113 1342.30588,226.844706 1503.13412,425.282353 L1503.13412,425.282353 L1415.26588,496.435294 C1276.00941,324.538824 1068.98824,225.941176 847.058824,225.941176 C442.277647,225.941176 112.941176,555.277647 112.941176,960.058824 C112.941176,1364.84 442.277647,1694.17647 847.058824,1694.17647 C1068.98824,1694.17647 1276.00941,1595.57882 1415.26588,1423.68235 L1415.26588,1423.68235 L1503.13412,1494.83529 C1342.30588,1693.27294 1103.20941,1807.11765 847.058824,1807.11765 C379.934118,1807.11765 0,1427.18353 0,960.058824 C0,492.934118 379.934118,113 847.058824,113 Z M976.534588,524.817412 L1056.384,604.779765 L757.428706,903.622118 L1920.04518,903.622118 L1920.04518,1016.45035 L757.428706,1016.45035 L1056.384,1315.40565 L976.534588,1395.25506 L541.372235,960.092706 L976.534588,524.817412 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconToggleLeftLine = /*#__PURE__*/function (_Component) {
  _inherits(IconToggleLeftLine, _Component);

  var _super = _createSuper(IconToggleLeftLine);

  function IconToggleLeftLine() {
    _classCallCheck(this, IconToggleLeftLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconToggleLeftLine, [{
    key: "render",
    value: function render() {
      if (process.env.NODE_ENV !== 'production') {}

      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconToggleLeft",
        viewBox: "0 0 1920 1920",
        bidirectional: true
      }), _ref);
    }
  }]);

  IconToggleLeftLine.displayName = "IconToggleLeftLine";
  return IconToggleLeftLine;
}(Component);

IconToggleLeftLine.glyphName = 'toggle-left';
IconToggleLeftLine.variant = 'Line';
IconToggleLeftLine.deprecated = true;
IconToggleLeftLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconToggleLeftLine;
export { IconToggleLeftLine };